import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri, filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getFreeServices = createAsyncThunk(
  "contracts/getFreeServices",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/free-services?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            'Content-Type': 'application/json',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createFreeService = createAsyncThunk(
  "contracts/createFreeService",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.post(
        `${apiUri}/free-services`,
        args,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateFreeService = createAsyncThunk(
  "contracts/updateFreeService",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.put(
        `${apiUri}/free-services/${args._id}`,
        args.values,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteFreeService = createAsyncThunk(
  "contracts/deleteFreeService",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.delete(
        `${apiUri}/free-services/${args._id}`,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
)

const contractsSlice = createSlice({
  name: "contracts",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFreeServices.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFreeServices.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getFreeServices.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createFreeService.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createFreeService.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // state.itemsCount++;
        // state.data.push(payload.data);
        state.error = null;
      })
      .addCase(createFreeService.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateFreeService.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateFreeService.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // const indexAt = state.data?.findIndex(el => el._id === payload.data._id);
        // state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateFreeService.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteFreeService.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteFreeService.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteFreeService.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default contractsSlice.reducer;